import react from 'react';
import { CircleFlag, CircleFlagLanguage } from 'react-circle-flags';
import * as Styled from './CountryOptionLabel.styled';

const CountryOptionLabel = ({ value, label }) => {
  let countryCode = '';

  /** need to explicitly define taiwan because zh language code shows Chinese flag */
  if (value === 'zh-TW') {
    countryCode = 'tw';
  }

  const flag = () => {
    if (value === 'en-US') {
      return (
        <Styled.CombinedFlags>
          <CircleFlag countryCode="us" height="22" />
          <Styled.OverlaidCircleFlag countryCode="gb" height="22" />
        </Styled.CombinedFlags>
      );
    } else if (countryCode) {
      return <CircleFlag countryCode={countryCode} height="22" />;
    } else {
      return (
        <CircleFlagLanguage languageCode={value.split('-')[0]} height="22" />
      );
    }
  };

  return (
    <Styled.Wrapper>
      {flag()}
      <div>{label}</div>
    </Styled.Wrapper>
  );
};

export default CountryOptionLabel;
